/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuyMobileNavRefineMenuFilters_user = {
    readonly " $fragmentRefs": FragmentRefs<"SbMobileRefineMenuFilterPrice_user" | "SbMobileRefineMenuFilterDimensions_user">;
    readonly " $refType": "BuyMobileNavRefineMenuFilters_user";
};
export type BuyMobileNavRefineMenuFilters_user$data = BuyMobileNavRefineMenuFilters_user;
export type BuyMobileNavRefineMenuFilters_user$key = {
    readonly " $data"?: BuyMobileNavRefineMenuFilters_user$data;
    readonly " $fragmentRefs": FragmentRefs<"BuyMobileNavRefineMenuFilters_user">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyMobileNavRefineMenuFilters_user",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterPrice_user"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SbMobileRefineMenuFilterDimensions_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};
(node as any).hash = 'f2255d7cd3c397691c4a9b8df33f7764';
export default node;
